import { render, staticRenderFns } from "./VisualAcuity.vue?vue&type=template&id=ace2f2ea&"
import script from "./VisualAcuity.vue?vue&type=script&lang=js&"
export * from "./VisualAcuity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports